import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-35" data-mp="bookx19fxr2w">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 md:inset-x-auto md:right-6 md:bottom-6 md:px-0 md:pb-0" data-id="element-36" data-mp="196gawv4bwhoi">
          <a href={CHECKOUT_URL} className="animate-shake flex w-full items-center justify-center gap-2.5 rounded-2xl bg-cta px-6 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-6px_rgba(22,163,74,0.7)] ring-2 ring-white transition-colors duration-150 ease-out hover:bg-cta-dark md:w-auto md:text-lg" data-id="element-37" data-mp="2f3it8kxv3140">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-38" data-mp="1welzci6dmamb" />
            <span data-id="element-39" data-mp="1ieb7pcx8ss03">Get it now for $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}